import { CONSTANTS } from "src/constants";
import { COMMON_CONSTANTS } from "src/constants/commonConstants";
import { JOB_CONSTANTS } from "src/constants/job.constants";
import { URL_CONSTANTS } from "src/constants/url.constants";
import {
  FindProspectsPayload,
  PostedJobsPayload,
} from "src/models/common.model";
import {
  AssignRecruiterPayload,
  JobFulFillPayload,
} from "src/models/job.model";
import { NotesQueryParams } from "src/models/notes.models";
import {
  PatchPayloadProps,
  PayloadProps,
  PutPayloadProps,
} from "src/models/service.models";
import commonUtils, { urlReplace } from "src/utils/common.utils";

import API_URL from "./apiConfig/api.config";
import handleResponse from "./apiConfig/api.response.service";
import apiCall from "./apiConfig/apiCall.config";

export async function assignApplicant(
  data: PatchPayloadProps,
  id: string,
  isEdit?: boolean
) {
  const res = await apiCall.patch(
    isEdit
      ? API_URL.JOB.ASSIGN_APPLICANT + id + URL_CONSTANTS.RE_ASSIGN_APPLICANT
      : API_URL.JOB.ASSIGN_APPLICANT + id + URL_CONSTANTS.ASSIGN_APPLICANT,
    data
  );
  const responseData = await handleResponse(
    res,
    CONSTANTS.DISABLED,
    CONSTANTS.DISABLED
  );
  return responseData;
}

export const fulfillJob = async (payload: JobFulFillPayload) => {
  const res = await apiCall.patch(API_URL.JOB.FULL_FILL, payload);
  const responseData = await handleResponse(res);
  if (responseData.ok) {
    return responseData?.data;
  } else {
    return responseData;
  }
};
export const getBillRate = async (
  officeUuid: string,
  params?: {
    pay_rate?: string;
  }
) => {
  const url = commonUtils.getUrlReplace(
    API_URL.JOB.GET_BILL_RATE,
    COMMON_CONSTANTS.UUID,
    officeUuid
  );
  const res = await apiCall.get(url, {
    ...params,
  });
  const responseData = await handleResponse(
    res,
    CONSTANTS.DISABLED,
    CONSTANTS.DISABLED
  );

  return responseData;
};
export const getBillDetails = async (id: string, date: string) => {
  const res = await apiCall.get(
    API_URL.JOB.GET_BILL_DETAILS + id + URL_CONSTANTS.GET_BILL_DETAILS + date
  );
  const responseData = await handleResponse(res);
  if (responseData.ok) {
    return responseData?.data;
  } else {
    return responseData;
  }
};

export const getCity = async () => {
  const res = await apiCall.get(API_URL.COMMON.CITY);
  const responseData = await handleResponse(res);
  if (responseData.ok) {
    return responseData?.data;
  } else {
    return responseData;
  }
};

export async function getJobData(id: string) {
  return await apiCall.get(API_URL.JOB.GET_JOB_DATA + id);
}

export async function getJobLogs(id: string) {
  const url = urlReplace(API_URL.JOB.GET_JOB_LOGS, JOB_CONSTANTS.UUID, id);
  return await apiCall.get(url);
}

export async function getProfessionalForJob(
  id: string,
  parms: { [key: string]: Array<number> | string | number }
) {
  return await apiCall.get(
    API_URL.JOB.GET_JOB_DATA_PROFESSIONAL +
      id +
      URL_CONSTANTS.GET_JOB_PROFESSIONAL,
    parms
  );
}

export async function getProfessionalForJobFind(
  id: string,
  params: PostedJobsPayload
) {
  return await apiCall.get(
    API_URL.JOB.GET_JOB_DATA_PROFESSIONAL +
      id +
      URL_CONSTANTS.FIND_JOB_PROFESSIONAL,
    { ...params }
  );
}

export const getTimesheets = async (dateUUID: string) => {
  return await apiCall.get(API_URL.JOB.GET_TIMESHEET + dateUUID);
};

export async function getAssignedShortlistProfessional(
  id: string,
  params: PostedJobsPayload
) {
  return await apiCall.get(
    API_URL.JOB.GET_JOB_DATA_PROFESSIONAL +
      id +
      URL_CONSTANTS.GET_JOB_PROFESSIONAL,
    { ...params }
  );
}
export async function ShortlistProfessional(
  id: string,
  params: PutPayloadProps
) {
  return await apiCall.post(
    API_URL.JOB.GET_JOB_DATA_PROFESSIONAL +
      id +
      URL_CONSTANTS.SHORTLIST_PROFESSIONAL,
    { ...params }
  );
}

export async function unassignApplicant(data: PatchPayloadProps, id: string) {
  const res = await apiCall.patch(
    API_URL.JOB.ASSIGN_APPLICANT + id + URL_CONSTANTS.UNASSIGN_APPLICANT,
    data
  );
  const responseData = await handleResponse(res);
  return responseData;
}

export const createExpense = async (data: FormData, id: string) => {
  const url = commonUtils.urlReplace(
    API_URL.TIMESHEET_EXPENSES.CREATE,
    CONSTANTS.COMMON_CONSTANTS.TIMESHEET_UUID,
    id
  );
  const res = await apiCall.fileUploadApi(url, data);
  const responseData = handleResponse(res);
  return responseData;
};

export async function getProspectForJobFind(
  id: string,
  params: FindProspectsPayload
) {
  return await apiCall.get(
    API_URL.JOB.FIND_PROSPECTS + id + URL_CONSTANTS.FIND_PROSPECTS,
    { ...params }
  );
}

export async function assignRecruiter(data: AssignRecruiterPayload) {
  const res = await apiCall.patch(API_URL.JOB.ASSIGN_RECRUITER, data);
  const responseData = await handleResponse(res);
  return responseData;
}
export async function unAssignRecruiter(data: {
  job_uuid: string;
  recruiter_uuid: string;
}) {
  const res = await apiCall.patch(API_URL.JOB.UN_ASSIGN_RECRUITER, data);
  const responseData = await handleResponse(res);
  return responseData;
}
export async function getRecruitersForJob(params: {
  job: string[];
  search?: string;
}) {
  const res = await apiCall.post(API_URL.JOB.GET_RECRUITERS, {
    ...params,
  });
  const responseData = await handleResponse(res);
  return responseData;
}

export async function getRecruitersJobList(params?: PostedJobsPayload) {
  const res = await apiCall.get(API_URL.JOB.GET_RECRUITERS_JOB, {
    ...params,
  });
  const responseData = await handleResponse(res);

  return responseData;
}

export async function getMyAssignmentsList(
  userId: string,
  params?: PostedJobsPayload
) {
  const url = commonUtils.urlReplace(
    API_URL.JOB.GET_MY_ASSIGNMENTS_JOB,
    CONSTANTS.COMMON_CONSTANTS.USER_ID,
    userId
  );
  const res = await apiCall.get(url, {
    ...params,
  });
  const responseData = await handleResponse(res);

  return responseData;
}

export async function addJobNotes(data: PayloadProps) {
  const res = await apiCall.post(API_URL.JOB.ADD_NOTE, data);
  const responseData = await handleResponse(res);
  return responseData;
}

export async function editJobNotes(uuid: string, data: PutPayloadProps) {
  const url = urlReplace(
    API_URL.JOB.EDIT_NOTE,
    COMMON_CONSTANTS.NOTE_UUID,
    uuid
  );
  const res = await apiCall.patch(url, data);
  const responseData = await handleResponse(res);
  return responseData;
}

export async function getJobNotes(uuid: string, params?: NotesQueryParams) {
  const url = urlReplace(API_URL.JOB.GET_NOTES, COMMON_CONSTANTS.JOB_ID, uuid);
  const res = await apiCall.get(url, { ...params });
  const responseData = await handleResponse(res);
  return responseData;
}
